import { compose } from 'ramda';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getIsAuthenticated } from 'store/selectors/auth';
import Header from 'components/Header';
import { getUserRole } from 'store/selectors/user';

const mapStateToProps = state => ({
  isAuthorized: getIsAuthenticated(state),
  role: getUserRole(state),
});

export default compose(
  withRouter,
  connect(mapStateToProps),
)(Header);
